import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import { getNonEmpty } from '../../../../utils/helpers';
import { alertError, alertSuccess } from '../../../../utils/logger';
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
    dateFormatter,
    substringFormatter
} from "../../../components/tables/table";
import { buttonFormatterEditDisableDelete } from "../../../components/tables/buttonFormatterTable";
import { changeStatusManufacturer, deleteManufacturer, getAllManufacturers } from "../../../../api/manufacturers";

function getData(manufacturers) {
    return manufacturers.map(manufacturer => ({
        fullName: manufacturer.fullName, //getNonEmpty(manufacturer.fullName),
        description: getNonEmpty(manufacturer.description),
        createdAt: manufacturer.createdAt,
        type: manufacturer?.type.join(", "),
        active: manufacturer.active,
        id: manufacturer._id,
    }));
}

export default function ManufacturersPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);

    const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
    const [refresh, setRefresh] = useState(false)
    const [data, setData] = useState([])
    const [manufacturer, setManufacturer] = useState(null);

    useEffect(() => {
        getAllManufacturers()
            .then((res) => {
                setData(getData(res.data));
                setRefresh(false);
            })
            .catch(error => {
                alertError({ error: error, customMessage: 'Could not get manufacturers.' })
            })
    }, [refresh]);


    const columns = [
        { dataField: "fullName", text: "Manufacturer Name", sort: true },
        { dataField: "type", text: "Types" },
        { dataField: "description", text: "Description", sort: true, formatter: substringFormatter },
        {
            dataField: "createdAt",
            text: "Created at",
            formatter: dateFormatter,
            sort: true,
        },
        {
            dataField: "id", text: "",
            formatter: (cell) => buttonFormatterEditDisableDelete(cell, "manufacturer", data, user?.role === "admin", setManufacturer, setOpenConfirmDialog, history),
            headerStyle: { width: '200px' }
        }
    ];

    return (
        <Card>
            <CardHeader title="Manufacturers list">
                <CardHeaderToolbar>
                    <button
                        type="button"
                        className="btn btn-primary text-white"
                        onClick={() => history.push("/edit-manufacturer")}
                    >
                        Add new
                    </button>
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                <Table data={data} columns={columns} key={data.length} />

                <ConfirmDialog
                    title={`Are you sure you want to ${manufacturer?.active ? "deactivate" : "activate"} this manufacturer?`}
                    open={openConfirmDialog === 1}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        changeStatusManufacturer(manufacturer.id, !manufacturer?.active)
                            .then((res) => {
                                alertSuccess({
                                    title: `${manufacturer?.active ? "Deactivate!" : "Activate!"
                                        }`,
                                    customMessage: `Manufacturer ${manufacturer?.active ? "deactivate" : "activate"
                                        } successfully`,
                                });
                                setRefresh(true);
                            })
                            .catch((error) => {
                                alertError({
                                    error: error,
                                    customMessage: `Could not ${manufacturer?.active ? "deactivate" : "activate"
                                        } the manfacturer.`,
                                });
                            });
                    }}
                />
                <ConfirmDialog
                    title={"Are you sure you want to delete this manufacturer?"}
                    open={openConfirmDialog === 2}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        deleteManufacturer(manufacturer.id)
                            .then((res) => {
                                alertSuccess({
                                    title: "Deleted!",
                                    customMessage: "Manufacturer deleted successfully.",
                                });
                                setRefresh(true);
                            })
                            .catch((error) => {
                                alertError({
                                    error: error,
                                    customMessage: "Could not delete the manufacturer.",
                                });
                            });
                    }}
                />
            </CardBody>
        </Card>
    );
}